import Cookies from 'js-cookie';
import { v4 as uuid } from 'uuid';
import { rootStore } from 'store/root';
import { serverOptions } from './server-options';

const { application, settings } = window;
// this middleware api will add createdate, clientip, arena_client_country info
const nxLogMiddlewareApiUrl = `${settings.hosts.accounts}/api/nxlog`;
const states: any = {};

const getState = (serviceId: string | number) => {
    const state = states[serviceId] || {
        sessionId: uuid(),
        prevStage: null,
    };
    return state;
};

const send = async (
    {
        comment,
        stage,
        productId,
        errorcode = 0,
        serviceId,
    }: {
        comment: string;
        stage: number;
        productId: string;
        errorcode?: number;
        serviceId?: string;
    },
    opts: any = {} // arena_error_code, arena_error_message
) => {
    if (!serviceId) {
        const product = rootStore.appStore.library.find((item) => item.productId === productId);
        serviceId =
            productId === '10300'
                ? serverOptions.find((one) => one.name === rootStore.session.selectedServer)?.serviceId // vidictus selected server's service id
                : product?.currentBranch?.serviceId;
    }

    if (!serviceId) return;

    const state = getState(serviceId);

    const data = {
        type: 'stability',
        currentstep: 4, // fixed value for all logs
        serviceid: serviceId,
        nexonsn: parseInt(application.globalUserNo || '0', 10),
        sessionid: state.sessionId,
        osplatform: 'Arena',
        stability: {
            comment,
            errorcode,
            prevstage: state.prevStage,
            stage,
            arena_membership_no: parseInt(application.params.region, 10),
            arena_membership_user_no: parseInt(application.userNo || '0', 10),
            arena_environment: application.params.environment,
            arena_product_id: productId,
            arena_session_id: Cookies.get('arenaSid'),
            arena_device_id: application.params.device_id,
            ...opts,
        },
    };
    // game launch end
    if (stage === 907) {
        delete states[serviceId];
    } else {
        state.prevStage = stage;
        states[serviceId] = state;
    }
    fetch(nxLogMiddlewareApiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
};
const nxLog = {
    send,
    getState,
};

export default nxLog;
